import download from 'downloadjs';

/**
 * Open blob in a new tab
 * @param {object} blob
 * @param {string} fileName
 */
export const openBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  window.open(url, fileName);
};

/**
 * Download or open blob in a new tab
 * @param {object} blob
 * @param {string} fileName
 * @param {bool} open flag for opening blob in a new tab
 */
export const downloadOrOpenBlob = (blob, fileName, open = false) => {
  if (open) {
    openBlob(blob, fileName);
  } else {
    download(blob, fileName);
  }
};
